<template>
  <footer class="footer has-background-dark has-text-info">
    <div class="columns">
      <div class="column has-text-right">
        <img src="@/assets/images/map.png" alt="">
      </div>
      <div class="column">
        <div class="container">
      <p>
      Elite Decor Inc.
    </p>
    <p>
      140 Delawanna Ave.
    </p>
    <p>
      Clifton, NJ 07014
    </p>
    </div>
    <div class="container">
      <p>
      Tel: (718) 369-4555
    </p>
    <p>
      Fax: (718) 369-4965
    </p>
    </div>
      </div>
    </div>
    <p class="has-text-centered">
      Copyright {{year}} - Elite Decor Inc.
    </p>
  </footer>
</template>

<script>
export default {
  computed: {
    year() {
      return new Date().getFullYear();
    },
  },
}
</script>

<style scoped>
.footer {
  padding-bottom: 1rem;
}
</style>
